/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  ListOrdersOptions,
  ListOrdersStatus200,
  ListOrdersStatus400,
  ListOrdersStatus401,
  ListOrdersStatus404,
  ListOrdersStatus500,
} from '../types/ListOrders'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listOrders } from '../clients/listOrders'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listOrdersQueryKey = ({ query }: Omit<ListOrdersOptions, 'headers'> = {}) =>
  [{ url: '/v1/orders' }, ...(query ? [query] : [])] as const

type ListOrdersQueryKey = ReturnType<typeof listOrdersQueryKey>

export function listOrdersQueryOptions(
  { query }: ListOrdersOptions = {},
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = listOrdersQueryKey({ query })
  return queryOptions<
    ListOrdersStatus200,
    ResponseErrorConfig<
      ListOrdersStatus400 | ListOrdersStatus401 | ListOrdersStatus404 | ListOrdersStatus500
    >,
    ListOrdersStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listOrders({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary List all orders
 * {@link /v1/orders}
 */
export function useListOrders<
  TData = ListOrdersStatus200,
  TQueryData = ListOrdersStatus200,
  TQueryKey extends QueryKey = ListOrdersQueryKey,
>(
  { query }: { query?: ListOrdersOptions['query'] | (() => ListOrdersOptions['query']) } = {},
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListOrdersStatus200,
        ResponseErrorConfig<
          ListOrdersStatus400 | ListOrdersStatus401 | ListOrdersStatus404 | ListOrdersStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? listOrdersQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...listOrdersQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      ListOrdersStatus400 | ListOrdersStatus401 | ListOrdersStatus404 | ListOrdersStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
